exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.editarProveedor .h2_title[data-v-35f2d055] {\n  font-weight: normal;\n}\n", ""]);

// exports
